import { render, staticRenderFns } from "./Table_fixed.vue?vue&type=template&id=088520c5&scoped=true&"
import script from "./Table_fixed.vue?vue&type=script&lang=js&"
export * from "./Table_fixed.vue?vue&type=script&lang=js&"
import style0 from "./Table_fixed.vue?vue&type=style&index=0&id=088520c5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088520c5",
  null
  
)

export default component.exports